import { authedHeaders } from '../../store/authStore';
import type { WorkspaceFolder, WorkspaceProject } from './types';

export type WorkspaceResourceType = 'app' | 'pipeline' | 'function' | 'agent' | 'object_type' | 'notebook' | 'connector';
export interface WorkspacePlacement {
  resourceType: WorkspaceResourceType;
  resourceId: string;
  projectId: string;
  folderId: string | null;
}
export interface WorkspaceManifest {
  projects: WorkspaceProject[];
  folders: WorkspaceFolder[];
  placements: WorkspacePlacement[];
  canOrganize: boolean;
}
export const emptyManifest = (): WorkspaceManifest => ({ projects: [], folders: [], placements: [], canOrganize: false });
const API = import.meta.env.VITE_ONTOLOGY_SERVICE_URL || 'http://localhost:8004';

export async function workspaceRequest<T>(path = '', method = 'GET', body?: unknown): Promise<T> {
  const response = await fetch(`${API}/workspace${path}`, { method, headers: authedHeaders({ 'Content-Type': 'application/json' }), ...(body === undefined ? {} : { body: JSON.stringify(body) }) });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(typeof data.detail === 'string' ? data.detail : 'No se pudo cargar o guardar la organización de archivos.');
  }
  return response.json();
}
